import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {AlertEventService} from './alert.event.service';
import {NG_POP_ALERT_CONF} from './ng-pop-alert.conf';
export class NgPopAlertComponent implements OnInit {
   overlay = true;
   styles = {};
public alert = {
    visible: false,
    message: '',
    type: '',
    alert_class: ''
  };
public alertClosure;
public message: SafeHtml | string = ``;
/**
 * @param {?} sanitizer
 * @param {?} alertEventService
 */
constructor(private sanitizer: DomSanitizer,
private alertEventService: AlertEventService) {
  }
/**
 * @return {?}
 */
private closeAlert() {
    this.alertClosure = setTimeout(() => {
      this.alert['visible'] = false;
    }, NG_POP_ALERT_CONF.duration);
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.alertEventService.on('AlertMessage', data => {
      clearTimeout(this.alertClosure);
      setTimeout(() => {
        this.alert = data;
        console.log('duration=', NG_POP_ALERT_CONF.duration);
        this.message = this.sanitizer.bypassSecurityTrustHtml(this.alert['message']);
        this.closeAlert();
      }, 200);
    });

    this.alertEventService.on('closeAlertMessage', () => {
      this.alert['visible'] = false;
      clearTimeout(this.alertClosure);
    });

  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng-pop-alert',
  template: `
    <div [class.notification-display]="overlay" class="bordered" [ngStyle]="styles" [hidden]="!alert['visible']">
      <div class="{{alert['alert_class']}}" role="alert" align="left" style="position: relative; padding: 10px;">
        <a role="button" (click)="alert['visible']=false" class="pull-right alert-link" style="cursor: pointer;">&nbsp;<b>&times;</b> </a>
        <span style="font-size:13px;" [innerHTML]="message"></span>
      </div>
    </div>
  `,
  styles: [`
    div.bordered {
      border-radius: 5px;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
    }

    div.alert-success {
      color: #3c763d !important;
      background-color: #dff0d8 !important;
      border-color: #d6e9c6 !important;
    }

    div.alert-success > a, div.alert-success > span {
      text-decoration: none !important;
      color: #3c763d !important;
    }

    div.alert-warning {
      color: #8a6d3b !important;
      background-color: #fcf8e3 !important;
      border-color: #faebcc !important;
    }

    div.alert-warning > a, div.alert-warning > span {
      text-decoration: none !important;
      color: #8a6d3b !important;
    }

    div .alert-danger {
      color: #a94442 !important;
      background-color: #f2dede !important;
      border-color: #ebccd1 !important;
    }

    div.alert-danger > a, div.alert-danger > span {
      text-decoration: none !important;
      color: #a94442 !important;
    }

    div.alert-info {
      color: #31708f !important;
      background-color: #d9edf7 !important;
      border-color: #bce8f1 !important;
    }

    div.alert-info > a, div.alert-info > span {
      text-decoration: none !important;
      color: #31708f !important;
    }

    .notification-display {
      position: fixed;
      min-width: 100px;
      width: auto !important;
      top: 10px;
      right: 10px;
      z-index: 100000 !important;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DomSanitizer, },
{type: AlertEventService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'overlay': [{ type: Input },],
'styles': [{ type: Input },],
};
}

function NgPopAlertComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgPopAlertComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPopAlertComponent.ctorParameters;
/** @type {?} */
NgPopAlertComponent.propDecorators;
/** @type {?} */
NgPopAlertComponent.prototype.overlay;
/** @type {?} */
NgPopAlertComponent.prototype.styles;
/** @type {?} */
NgPopAlertComponent.prototype.alert;
/** @type {?} */
NgPopAlertComponent.prototype.alertClosure;
/** @type {?} */
NgPopAlertComponent.prototype.message;
/** @type {?} */
NgPopAlertComponent.prototype.sanitizer;
/** @type {?} */
NgPopAlertComponent.prototype.alertEventService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
